(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7],{

/***/ 8083:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/forgot",
      function () {
        return __webpack_require__(8273);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1437);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1206);
/* harmony import */ var _components_pages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5257);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2917);
/* harmony import */ var notiflix__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4339);
/* harmony import */ var notiflix__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(notiflix__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9196);









const PasswordForgotPage = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { userStore  } = (0,_stores__WEBPACK_IMPORTED_MODULE_6__/* .useMst */ .Qb)();
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setShow(!show);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.asPath
    ]);
    const onSubmit = async (param)=>{
        let { email  } = param;
        setLoading(true);
        try {
            await userStore.authResetPasswordRequest(email);
            router.push("/password/forgot-sent");
        } catch (e) {
            if (e.response.status === 404) {
                router.push("/password/forgot-sent");
            } else {
                notiflix__WEBPACK_IMPORTED_MODULE_7__.Notify.failure("An error occurred, try again later.");
                setError({
                    message: "An error occurred, try again later."
                });
                (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .SentryCaptureException */ .fY)(e);
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pt-32 md:pt-36 pb-32 md:bg-light-blue min-h-screen",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .u, {
            show: show,
            enter: "transition ease-out duration-500",
            enterFrom: "opacity-0 translate-y-10",
            enterTo: "opacity-100 translate-y-0",
            leave: "transition ease-out duration-500",
            leaveFrom: "opacity-100 translate-y-0",
            leaveTo: "opacity-0 translate-y-10",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .rj, {
                className: "md:min-h-[76vh]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-span-4 md:col-span-8 md:col-start-3 flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:bg-white md:rounded-[60px] md:px-10 lg:px-32 md:py-[90px] w-full 2xl:max-w-[64rem] flex justify-start flex-col md:h-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-blue h2 mb-10 md:mb-8",
                                children: "Reset Password"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "copy-2 mb-8",
                                children: "Please verify your email and we'll send instructions to reset your password."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_4__/* .ForgotPasswordForm */ .Ld, {
                                error: error,
                                loading: loading,
                                onSubmit: onSubmit,
                                type: "reset"
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PasswordForgotPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8083); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);